<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Venta de Combustible</div>

    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <input id="fechafin" placeholder="Fecha final" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="280px">
                <Select2 v-model="cliente" :options="clientes" />
              </td>
              <td>
                <button class="btn btn-warning" type="button" :disabled="isBusy" @click="getReporteEquipos">
                  Consultar
                </button>
              </td>

              <td>
                <button class="btn btn-success" type="button" :disabled="isBusy" @click="exportarExcel">
                  <span class="ml-1">Descargar</span>
                </button>
              </td>

              <!-- Mensaje inline en la misma línea -->
              <td style="min-width:340px;">
                <span v-if="busyText" class="msg msg-info">
                  <i class="fa fa-spinner fa-spin"></i> {{ busyText }}
                </span>
                <span v-else-if="errorMsg" class="msg msg-error">
                  {{ errorMsg }}
                </span>
                <span v-else-if="infoMsg" class="msg msg-muted">
                  {{ infoMsg }}
                </span>
              </td>

              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <DataTable :columns="columns" :data="reporte" :options="options" class="display nowrap" style="width: 100%" />
      </div>

      <!-- RESUMEN EN 2 COLUMNAS -->
      <div class="resumen-grid">
        <!-- IZQUIERDA: RESUMEN POR MEDIOS DE PAGO -->
        <div class="resumen-col">
          <table width="100%" class="table font-oswald">
            <tbody>
              <tr class="fila-hover">
                <td class="subtable" colspan="2">RESUMEN CANTIDAD POR FORMA DE PAGO</td>
              </tr>

              <tr v-if="resumenPagosList.length === 0" class="fila-hover">
                <td class="subtable" colspan="2">Sin medios de pago</td>
              </tr>

              <tr v-for="(p, i) in resumenPagosList" :key="i" class="fila-hover">
                <td class="subtable">{{ p.medio_descripcion }}</td>
                <td class="subtable b text-right">{{ GLOBAL.FORMATO_NUMBER(p.valor) }}</td>
              </tr>

              <tr v-if="resumenPagosList.length > 0" class="fila-hover">
                <td class="subtable b">TOTAL CANTIDAD</td>
                <td class="subtable b text-right">{{ GLOBAL.FORMATO_NUMBER(resumenPagosTotal) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- DERECHA: RESUMEN ACTUAL -->
        <div class="resumen-col">
          <table width="100%" class="table font-oswald">
            <tbody>
              <tr class="fila-hover">
                <td class="subtable" width="150px">TRANSACCIONES</td>
                <td class="subtable b text-right">
                  {{ totalventas }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL CANTIDAD</td>
                <td class="subtable b text-right">
                  {{ fcantidad }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL IMPUESTOS</td>
                <td class="subtable b text-right">
                  {{ ftotalimpuestos }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL VENTAS</td>
                <td class="subtable b text-right">
                  {{ ftotales }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL DESCUENTOS</td>
                <td class="subtable b text-right">
                  {{ fdescuentos }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">FECHA INICIO</td>
                <td class="subtable b text-right">
                  {{ fecha_inicio_reporte }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">FECHA FINAL</td>
                <td class="subtable b text-right">
                  {{ fecha_final_reporte }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Venta # {{ venta._id }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-gray">
              <div class="bg-gray">
                <div class="bg-gray">
                  <FacturaPosView :key="facturaKey" :object="factura" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import FacturaPosView from "../../components/FacturaPosView.vue";
import ClienteService from "../../service/ClienteService";

import Select2 from "vue3-select2-component";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(Buttons);
DataTable.use(ButtonsHtml5);

export default {
  components: { DataTable, FacturaPosView, Select2 },
  data() {
    return {
      loading: false,
      loadingExport: false,
      busyText: "",
      errorMsg: "",
      infoMsg: "",
      GLOBAL,
      FACTOR_CONVERSION: 1.11112,
      table: null,
      reporteService: null,
      person: null,
      cache: false,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totaleds: 0,
      totalimpuestos: 0,
      totales: 0,
      descuentos: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      fdescuentos: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      venta: [],
      facturaKey: 0,
      factura: [],
      datatable: null,
      clienteService: null,
      clientes: [],
      cliente: "",
      documento_id: "",
      page: 0,

      // NUEVO: resumen por medios de pago
      resumenPagos: {}, // { "EFECTIVO": 123, "TARJETA": 456 }
      resumenPagosList: [], // [{medio_descripcion, valor}]
      resumenPagosTotal: 0,

      columns: [
        { title: "Fecha", class: "text-center", data: "fecha" },
        {
          title: "Mang",
          width: "80px",
          data: "manguera",
          render: function (data, type, row) {
            return "M." + row.manguera;
          },
        },
        {
          title: "Prefijo/Consecutivo",
          render: function (data, type, row) {
            return row.prefijo + "-" + row.consecutivo;
          },
        },
        {
          title: "Hash",
          data: "hash",
          render: function (data, type, row) {
            return row.hasp;
          },
        },
        { title: "Promotor", data: "persona_nombre" },
        { title: "Cliente", data: "tercero_nit" },
        { title: "Cliente", data: "tercero_nombre" },
        { title: "Producto", data: "producto_nombre" },
        { title: "UND", data: "unidad_codigo" },
        {
          title: "Precio",
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.producto_precio);
          },
        },
        { title: "Cant", data: "cantidad", class: "text-right" },
        {
          title: "Cant m3",
          data: "cantidadm3",
          class: "text-right",
          render: function (data, type, row) {
            var factorConversion = this.FACTOR_CONVERSION;
            if (row.unidad_id == 2) {
              factorConversion = 1;
            }

            return GLOBAL.COUNTRY == "MX"
              ? GLOBAL.FORMATO_NUMBER(row.cantidad / factorConversion)
              : "";
          }.bind(this),
        },
        {
          title: "Descuento",
          class: "text-center",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.descuento_total);
          },
        },
        {
          title: "Venta",
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.venta_total);
          },
        },
        {
          title: "MPago1",
          class: "text-left",
          render: function (data, type, row) {
            const pagos = Array.isArray(row.medios_pago) ? row.medios_pago : [];
            if (pagos.length < 1) return "";
            const p = pagos[0];
            // backend: medio_descripcion, valor, medio_pago_id
            //return `${p.medio_descripcion || ""} ${GLOBAL.FORMATO_MONEY_BASIC(p.valor || 0)}`;
            return p.medio_descripcion;
          },
        },
        {
          title: "MPago2",
          class: "text-left",
          render: function (data, type, row) {
            const pagos = Array.isArray(row.medios_pago) ? row.medios_pago : [];
            if (pagos.length < 2) return "";
            const p = pagos[1];
            return p.medio_descripcion;
          },
        },
        {
          title: "MPago3",
          class: "text-left",
          render: function (data, type, row) {
            const pagos = Array.isArray(row.medios_pago) ? row.medios_pago : [];
            if (pagos.length < 3) return "";
            const p = pagos[2];
            return p.medio_descripcion;
          },
        },
        {
          title: "Acciones",
          data: "boton",
          render: function (data, type, row) {
            return "";
          },
        },
      ],
      options: {
        ...GLOBAL.TABLE_OPTIONS,
        createdRow: function (row, data, dataIndex) {
          const vueInstance = this;
        }.bind(this),
      },
    };
  },
  computed: {
    isBusy() {
      return this.loading || this.loadingExport;
    },
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));

    this.FACTOR_CONVERSION = 1;
    try {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
      console.log(this.FACTOR_CONVERSION);
    } catch (error) { }

    this.permiso_lista = this.person.funciones.includes(GLOBAL.PERMISOS.REPORTE.HOROMETRO);
    this.reporteService = new ReporteService();
    this.clienteService = new ClienteService();
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
      "-" +
      (fecha.getMonth() + 1 <= 9 ? "0" + (fecha.getMonth() + 1) : fecha.getMonth() + 1) +
      "-" +
      (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
      " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
      "-" +
      (fecha.getMonth() + 1 <= 9 ? "0" + (fecha.getMonth() + 1) : fecha.getMonth() + 1) +
      "-" +
      (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
      " 23:59"
    );
    $("input[datatype='fecha']").datetimepicker();
    this.getReporteEquipos();
    this.getListaCliente();
  },
  methods: {
    refrescarFactura() {
      this.facturaKey += 1;
    },
    limpiarCliente() {
      this.cliente = "";
    },
    openMe(item) {
      this.venta = item;
      this.venta.hash = this.venta.hasp;
      this.venta.numero = this.venta.consecutivo;
      this.venta.hash = this.venta.hasp;

      this.reporteService
        .getFactura(this.person, this.venta)
        .then((data) => {
          this.factura = data;
          if (typeof this.venta.hasp != "undefined") {
            this.factura.hash = this.venta.hasp;
          }
          this.refrescarFactura();
        })
        .then(() => {
          $("#myModal").modal("show");
        });
    },

    changeMe: function (movimiento) {
      if (this.clientes.length == 0) {
        this.getListaCliente();
      }
      this.documento_id = movimiento.documento_id;
      $("#myChange").modal("show");
    },

    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          this.clientes = [];
          for (var i in data) {
            this.clientes.push({ id: data[i]._id, text: data[i].nombres });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    calcularResumenMediosPago() {
      this.resumenPagos = {};
      this.resumenPagosList = [];
      this.resumenPagosTotal = 0;

      let totalCredito = 0;
      let totalContado = 0;

      for (const r of this.reporte) {
        const cantidad = Number(r.cantidad || 0);
        const pagos = Array.isArray(r.medios_pago) ? r.medios_pago : [];

        const esCredito = pagos.some((p) => {
          const desc = String(p.medio_descripcion || "").trim().toUpperCase();
          return desc == ("CREDITO") || desc == ("CRÉDITO");
        });

        if (esCredito) {
          totalCredito += cantidad;
        } else {
          totalContado += cantidad;
        }
      }

      this.resumenPagosList = [
        { medio_descripcion: "CRÉDITO", valor: totalCredito },
        { medio_descripcion: "CONTADO", valor: totalContado },
      ];

      this.resumenPagosTotal = totalCredito + totalContado;
    },

    getReporteEquipos() {
      if (this.isBusy) return;

      this.reporte = [];
      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();

      this.errorMsg = "";
      this.infoMsg = "";
      this.busyText = "Consultando reporte...";
      this.loading = true;

      const filtros = { cliente: this.cliente };

      this.reporteService
        .getListaMovimientos(this.person, fechainicio, fechafin, GLOBAL.TIPO_ORIGEN.COMBUSTIBLE, filtros)
        .then((data) => {
          this.reporte = Array.isArray(data.data) ? data.data : [];

          this.totalimpuestos = 0;
          this.totalCantidad = 0;
          this.totales = 0;
          this.descuentos = 0;

          for (const r of this.reporte) {
            this.totalimpuestos += r.impuesto_total || 0;
            this.totalCantidad += r.cantidad || 0;
            this.totales += r.venta_total || 0;
            this.descuentos += r.descuento_total || 0;
          }

          this.totalventas = this.reporte.length;
          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
          this.fdescuentos = GLOBAL.FORMATO_MONEY(this.descuentos);

          this.fecha_inicio_reporte = fechainicio;
          this.fecha_final_reporte = fechafin;

          // NUEVO: resumen por medios de pago
          this.calcularResumenMediosPago();

          if (this.reporte.length === 0) {
            this.infoMsg = "No se encontraron registros.";
          }
        })
        .catch((e) => {
          console.error(e);
          this.errorMsg = "Error consultando el reporte.";
        })
        .finally(() => {
          this.loading = false;
          this.busyText = "";
        });
    },

    buildFilename() {
      const fi = ($("#fechainicio").val() || "").replace(/[: ]/g, "-");
      const ff = ($("#fechafin").val() || "").replace(/[: ]/g, "-");
      return `reporte_venta_combustible_${fi}_${ff}.xlsx`;
    },

    async exportarExcel() {
      if (this.isBusy) return;

      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();

      if (!fechainicio || !fechafin) {
        this.errorMsg = "Seleccione fecha inicio y fecha final.";
        return;
      }

      this.errorMsg = "";
      this.infoMsg = "";
      this.busyText = "Generando Excel, por favor espere...";
      this.loadingExport = true;

      const filtros = { cliente: this.cliente };

      try {
        const res = await this.reporteService.exportListaMovimientosExcel(
          this.person,
          fechainicio,
          fechafin,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE,
          filtros
        );

        const ct = (res.headers?.["content-type"] || "").toLowerCase();
        if (!String(res.status).startsWith("2") || ct.includes("application/json") || ct.includes("text")) {
          try {
            const txt = new TextDecoder("utf-8").decode(new Uint8Array(res.data));
            this.errorMsg = "El servidor devolvió un error: " + txt;
          } catch (e) {
            this.errorMsg = "Error exportando Excel (respuesta no válida).";
          }
          return;
        }

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.buildFilename();
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        this.infoMsg = "Excel generado.";
      } catch (e) {
        console.error(e);
        this.errorMsg = "Error exportando Excel.";
      } finally {
        this.loadingExport = false;
        this.busyText = "";
      }
    },
  },
};
</script>

<style>
.resumen-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.resumen-col {
  flex: 1 1 320px;
  min-width: 320px;
}
</style>
